import { render, staticRenderFns } from "./GebindeComponent.vue?vue&type=template&id=a3d10926"
import script from "./GebindeComponent.vue?vue&type=script&lang=ts"
export * from "./GebindeComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports